<style scoped>
.el-col-5 {
  width: 33%;
}

/deep/.el-drawer__header {
  margin-bottom: 30px !important;
}

.arrive-detail-title {
  margin-bottom: 30px;
}

/deep/.el-progress {
  float: left;
  width: 80%;
}

.search-area-div {
  width: 90px !important
}

.cost-detail-item {
  display: flex;
  padding: 30px;
}

.ticket-inform {
  padding: 20px;
}


.ticket-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ticket-item {
  display: flex;
  text-align: left;
  margin-bottom: 15px;
}

.ticket-right {
  width: 120px;
  height: 70px;
  border: 1px solid#dcdfe6;
}

.ticket-right img {
  width: 120px;
  height: 70px;
}

.ipt-sty {
  width: 70% !important;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="5">
          <div class="search-area-div">供应商：</div>
          <el-input v-model="page.supplierName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
        </el-col>
        <el-col :span="5">
          <div class="search-area-div">付款状态：</div>
          <el-select v-model="page.paymentState" placeholder="请选择" class="ipt-sty" :clearable="true">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option> </el-select>
        </el-col>
        <el-col :span="5">
          <div class="search-area-div">开票状态：</div>
          <el-select v-model="page.invoiceState" placeholder="请选择" class="ipt-sty" :clearable="true">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option> </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="5">
          <div class="search-area-div">年度：</div>
          <el-date-picker v-model="page.year" type="year" placeholder="选择年" class="ipt-sty"> </el-date-picker>
        </el-col>
        <el-col :span="5">
          <div class="search-area-div">月度：</div>
          <el-select class="w70f" v-model="page.month" placeholder="请选择" :clearable="true">
            <el-option v-for="item in optionsMonth" :key="item.value" :label="item.label" :value="item.value">
            </el-option> </el-select>
        </el-col>
        <el-col :span="5" class="t-right">
          <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button size="medium" @click="openSummary">汇总统计</el-button>
      <el-button size="medium" @click="report">导出</el-button>
    </div>
    <div class="back-color-fff p16" style="padding: 16px">
      <el-table :data="fillReceiptData" style="width: 100%; margin-bottom: 20px" border v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="供应商" header-align="center" align="left" width="250"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="year" label="年度" header-align="center" align="center" width="60"> </el-table-column>
        <el-table-column prop="month" label="月份" header-align="center" align="center" width="60"> </el-table-column>
        <el-table-column prop="payableAmount" label="应付款" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.payableAmount | numDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paymentState" label="付款状态" header-align="center" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.paymentState | getPaymentState }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receiptAmount" label="实际到账" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.receiptAmount | numDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="欠款" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            <span>{{ (scope.row.payableAmount - scope.row.receiptAmount) | numDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceState" label="开票状态" header-align="center" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceState | getInvoiceState }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开票金额" header-align="center" align="right" width="150" prop="invoiceAmount">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceAmount | numDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="待开票" header-align="center" align="right" width="150">
          <template slot-scope="scope">
            <span>{{ (scope.row.receiptAmount - scope.row.invoiceAmount) | numDigit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center"  fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="getFillDetail(scope.row)">付款详情</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- 付款详情抽屉 -->
    <fill-detail ref="fillDetail" :fillDetailData="fillDetailData"></fill-detail>
  </div>
</template>
<script>
import FillDetail from '@/components/operatingDrawer/fillDetail';
export default {
  data() {
    return {
      fillDetailData: '',
      fillReceiptData: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: '',
        year: this.$route.query.year,
        month: this.$route.query.month,
        invoiceState: this.$route.query.invoiceState,
        supplierName: this.$route.query.supplierName,
        paymentState: this.$route.query.paymentState,
      },
      //收费状态
      options1: [
        {
          value: 'Y',
          label: '已付清',
        },
        {
          value: 'P',
          label: '未付清',
        },
        {
          value: 'N',
          label: '未付',
        },
      ],
      //开票状态
      options2: [
        {
          value: '1',
          label: '全额已开',
        },
        {
          value: '2',
          label: '部分已开',
        },
        {
          value: '3',
          label: '未开票',
        },
      ],
      //月度
      optionsMonth: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
      ],
      sheetData: [],
      loading: false,
    };
  },
  watch: {
    fillDetailData: {
      handler(newValue, oldValue) {
        console.log(newValue);
      },
      deep: true,
    },
  },
  created() {
    // 列表
    this.getData();
    // this.getDataList();
  },
  methods: {
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD('/ms-common-admin-cloud-service/excel/export', {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    report() {
      let self = this;
      let invoiceState = self.page.invoiceState;
      let medGuid = self.$store.state.medGuid;
      // let pageIndex = self.page.pageIndex;
      // let pageSize = self.page.pageSize;
      let supplierName = self.page.supplierName;
      let paymentState = self.page.paymentState;
      let month = self.page.month;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.api.postCan(`/ms-data-business-service/operating-costs/export?invoiceState=` +
        invoiceState +
        `&isAck=Y` +
        `&medGuid=` +
        medGuid +
        `&month=` +
        month +
        `&paymentState=` +
        paymentState +
        `&supplierName=` +
        supplierName +
        `&year=` +
        year).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data)
            self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //搜索
    searchData() {
      let self = this;
      self.getData();
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        invoiceState: '',
        medGuid: self.$store.state.medGuid,
        month: '',
        paymentState: '',
        supplierName: '',
        year: '',
      };
      self.getData();
    },
    //获取数据列表
    getData() {
      let self = this;
      self.loading = true;
      let invoiceState = self.page.invoiceState;
      let medGuid = self.$store.state.medGuid;
      let pageIndex = self.page.pageIndex;
      let pageSize = self.page.pageSize;
      let supplierName = self.page.supplierName;
      let paymentState = self.page.paymentState;
      let month = self.page.month;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.api
        .get(
          `/ms-data-business-service/operating-costs/get-operating-costs-list?invoiceState=` +
          invoiceState +
          `&isAck=Y` +
          `&medGuid=` +
          medGuid +
          `&month=` +
          month +
          `&paymentState=` +
          paymentState +
          `&supplierName=` +
          supplierName +
          `&year=` +
          year +
          `&pageIndex=` +
          pageIndex +
          `&pageSize=` +
          pageSize
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fillReceiptData = res.data.data.records;
            self.sheetData = JSON.parse(JSON.stringify(res.data.data.records));
            self.loading = false;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
            console.log(res.data);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    openSummary() {
      this.$router.push({
        path: '/statisticalReport/statisticalReportDetail/summaryStatistics',
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    //填报详情
    getFillDetail(row) {
      let self = this;
      self.$refs.fillDetail.showFillDetail = true;
      self.$refs.fillDetail.getInvoiceDetail(row.guid);
      self.fillDetailData = row;
      console.log(row);
    },
  },
  components: {
    FillDetail,
  },
};
</script>